import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faChartLine, 
  faUtensils, 
  faClock,
  faMobile,
  faChartPie,
  faBell
} from '@fortawesome/free-solid-svg-icons';
import '../styles/components/features.css';
import { useTranslation } from 'react-i18next';

function Features() {
  const { t } = useTranslation();

  return (
    <div className="features-page">
      <h1>{t('features.title')}</h1>
      
      <div className="features-grid">
        <div className="feature-card">
          <div className="feature-icon">
            <FontAwesomeIcon icon={faChartLine} />
          </div>
          <h2>{t('features.cards.glucose.title')}</h2>
          <p>{t('features.cards.glucose.description')}</p>
        </div>
        
        <div className="feature-card">
          <div className="feature-icon">
            <FontAwesomeIcon icon={faUtensils} />
          </div>
          <h3>{t('homepage.features.cards.meals.title')}</h3>
          <p>{t('homepage.features.cards.meals.description')}</p>
        </div>
        
        <div className="feature-card">
          <div className="feature-icon">
            <FontAwesomeIcon icon={faClock} />
          </div>
          <h3>{t('homepage.features.cards.reminders.title')}</h3>
          <p>{t('homepage.features.cards.reminders.description')}</p>
        </div>
        
        <div className="feature-card">
          <div className="feature-icon">
            <FontAwesomeIcon icon={faMobile} />
          </div>
          <h2>{t('features.cards.sync.title')}</h2>
          <p>{t('features.cards.sync.description')}</p>
        </div>
        
        <div className="feature-card">
          <div className="feature-icon">
            <FontAwesomeIcon icon={faChartPie} />
          </div>
          <h2>{t('features.cards.reports.title')}</h2>
          <p>{t('features.cards.reports.description')}</p>
        </div>
        
        <div className="feature-card">
          <div className="feature-icon">
            <FontAwesomeIcon icon={faBell} />
          </div>
          <h2>{t('features.cards.alerts.title')}</h2>
          <p>{t('features.cards.alerts.description')}</p>
        </div>
      </div>
    </div>
  );
}

export default Features;